import { Skeleton } from '@mui/material';

export interface GenericGroupingContainerProps {
  groupName: string;
  children: React.ReactNode;
  id?: string;
  dataTestId?: string;
  loading?: boolean;
  className?: string;
}

export const GenericGroupingContainer = ({
  groupName,
  children,
  id,
  dataTestId,
  loading,
  className,
}: GenericGroupingContainerProps) => {
  return (
    <div
      id={id}
      className={`card ${className}`}
      data-testid={dataTestId || 'generic-grouping-container'}
    >
      <div>
        <h2 className="headline-2">
          {groupName || (
            <Skeleton variant="text" role="status" aria-label="Loading..." />
          )}
        </h2>

        {!loading ? (
          children
        ) : (
          <Skeleton
            variant="rectangular"
            height={300}
            role="status"
            aria-label="Loading..."
          />
        )}
      </div>
    </div>
  );
};
